import { Sidebar } from '@futrli/ui-components';
import Typography from 'carbon-react/lib/components/typography';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import Form from 'carbon-react/lib/components/form';
import Button from 'carbon-react/lib/components/button';

import { SyncControlContainer } from './sync-control/sync-control-container';
import { SyncControlVariant } from './sync-control/types';

interface Props {
  isOpen: boolean;
  unreconciledTransactionsCount?: number | null;
  onClose: () => void;
}

export const DatasourceReconcileDrawer = ({
  isOpen,
  unreconciledTransactionsCount,
  onClose
}: Props) => {
  const intl = useIntl();

  return (
    <Sidebar
      header={
        <Typography variant="h2" fontWeight="700">
          <FormattedMessage id="predict.sync_data" defaultMessage="Sync data" />
        </Typography>
      }
      onCancel={onClose}
      open={isOpen}
      aria-label={intl.formatMessage({ id: 'predict.sync_data', defaultMessage: 'Sync data' })}
      size="medium-large"
    >
      <Form
        stickyFooter
        rightSideButtons={
          <Button onClick={onClose}>
            <FormattedMessage id="common.close" defaultMessage="Close" />
          </Button>
        }
        onSubmit={e => e.preventDefault()}
      >
        <aside
          aria-label={intl.formatMessage({
            id: 'predict.datasource_sync_time.aria_label',
            defaultMessage: 'Datasource sync time'
          })}
          style={{ width: '100%' }}
        >
          <SyncControlContainer
            variant={SyncControlVariant.SIDEBAR}
            unreconciledTransactionsCount={unreconciledTransactionsCount}
          />
        </aside>
      </Form>
    </Sidebar>
  );
};
